module.exports = __webpack_public_path__ + "static/media/card-design-congratulations.c76611e2.png";